function SpecsPreview({ specifications }) {
  if (!specifications || Object.keys(specifications).length === 0) return null;

  const priorityKeys = ['color', 'size', 'material', 'weight', 'capacity', 'screen_size', 'memory'];
  const displaySpecs = [];

  for (const key of priorityKeys) {
    if (specifications[key] && specifications[key] !== null) {
      const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
      displaySpecs.push({ key: formattedKey, value: specifications[key] });
      if (displaySpecs.length >= 2) break;
    }
  }

  if (displaySpecs.length === 0) return null;

  return (
    <div className="space-y-1">
      {displaySpecs.map((spec, index) => (
        <div key={index} className="flex justify-between text-xs">
          <span className="text-gray-600">{spec.key}:</span>
          <span className="text-gray-700 font-medium">{spec.value}</span>
        </div>
      ))}
    </div>
  );
}

export default SpecsPreview;
